module Omni.ResortMap {
    ngModule.factory('DataService', ['$resource', "$window", function ($resource, $window) {
        return $resource($window.endpointUrl);
    }])
        // underscore.js
        .factory('_', ["$window", function ($window: any) {

            return $window._;
        }])
        // Kinetic.js
        .factory('Kinetic', ["$window", function ($window: any) {

            return $window.Kinetic;
        }])
        // resort data object
        .factory('ResortProvider', ['_', function (_: any) {

            var resort,
                location,
                floor,
                room;
            var provider = {
                setResort: function (data) {
                    resort = data;
                },
                getResort: function () {
                    return resort;
                },
                getLocation: function (i) {
                    if (resort.is_resort) {
                        angular.forEach(resort.location, function (value, index) {
                            if (value.id == i) {
                                location = value;
                            }
                        });
                    } else {
                        location = resort.location[0];
                    }
                    return location;
                },
                getFloor: function (id) {
                    angular.forEach(location.floor, function (value, index) {
                        if (value.id == id) {
                            floor = value;
                        }
                    });
                    return floor;
                },
                getRoom: function (id) {
                    angular.forEach(floor.room, function (value, index) {
                        if (value.id == id) {
                            room = value;
                        }
                    });
                    return room;
                }
            };
            return provider;
        }]);
}
